import { MantineDataTable } from '@flexinet/ui-components';
import { Stack } from '@mantine/core';
import { useAllPersonas } from '../hooks/useAllPersonas';
import { usePersonasTableColumns } from '../hooks/usePersonasTableColumns';
import { DataTableTokenPagination } from '../../../components/DataTableTokenPagination';
import { useRef } from 'react';

export const PersonasTable = () => {
    const { visibleItems, loading, nextToken, fetchRecords, isFetchingNextPage, visibleCount } = useAllPersonas();
    const columns = usePersonasTableColumns();
    const scrollViewportRef = useRef<HTMLDivElement>(null);

    return (
        <Stack gap="lg">
            <MantineDataTable
                columns={columns}
                records={visibleItems}
                fetching={loading}
                withTableBorder={true}
                onScrollToBottom={fetchRecords}
                scrollViewportRef={scrollViewportRef}
            />
            <DataTableTokenPagination
                totalCount={visibleCount.toString()}
                nextToken={nextToken}
                handleLoadMore={fetchRecords}
                loading={isFetchingNextPage}
            />
        </Stack>
    );
};
